// extracted by mini-css-extract-plugin
module.exports = {"dfMenu":"dfMenu___HOq6v","content":"content___1jKBY","left":"left___19v2w","right":"right___3KKdR","item":"item___226az","rightitem":"rightitem___2TqQR","active":"active___F9oUx"};